import { useEffect, useState, useRef } from "react";
import { Outlet, useLoaderData, json, useNavigate, useLocation } from "react-router-dom";
import {Container, Row, Col} from 'react-bootstrap';

import NavigationComponent from "./components/Navigation.component";
import FooterComponent from "./components/Footer.component";
import UserInfoComponent from "./components/UserInfo.component";
import CookieComponent from "./components/Cookie.component";

export async function loader({params}){
  const expirationTime = new Date(localStorage.getItem('expires') * 1000);
  const currentTime = new Date();
  const userId = localStorage.getItem('jwt');
  if(userId === null || expirationTime.getTime() <= currentTime.getTime()){
    return null;
  }
  return json({data: 'data'});
}

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = useLoaderData();

  const [sessionLeftMinutes, setSessionLeftMinutes] = useState(0);

  useEffect(() => {
    if (data === null) {
      const currentLocation = location.pathname;
      if (currentLocation !== "/") {
        //localStorage.setItem('location', currentLocation);
      }
      return navigate('/authorization');
    }
  }, [data, location.pathname, navigate]);

  useEffect(() => {
    if(localStorage.getItem('expires') !== null){
      const sessionTimer = () => {
        const expirationTime = new Date(localStorage.getItem('expires') * 1000);
        const currentTime = new Date().getTime();

        const left = Math.floor(Math.floor((expirationTime-currentTime)/1000)/60);
        if(left < 1){
          return navigate('/authorization')
        }
        setSessionLeftMinutes(left);
      }
    
      const checkSessionInterval = setInterval(() => {
        sessionTimer()
      }, 30000);

      sessionTimer()
      return () => clearInterval(checkSessionInterval);
    }
  })

 
  return(
    <>
      <NavigationComponent sessionLeftMinutes={sessionLeftMinutes}/>
      <Container className="pageWrapper">
        <Outlet />
        <CookieComponent />
      </Container>
      <FooterComponent />
    </>
  )

}
export default HomePage;